import { AgentStatus } from '@entities/agent-status';
import type { StatusSyncCrmToAircallInput } from '@infra/controllers/status-sync-crm-to-aircall.controller';
import type { StatusSyncCrmToAircallMapper } from '@usecases/status-sync-crm-to-aircall.usecase';

type StatusMap = {
  [key in string]: string;
};

type AgentStatusMap = {
  [key in string]: AgentStatus;
};

export class CrmToAircallStatusMapper implements StatusSyncCrmToAircallMapper {
  private static ins: CrmToAircallStatusMapper;

  private phoneStatusMap: StatusMap = {
    available: 'always_opened',
    unavailable: 'always_closed',
  };

  private defaultCRMKeyMap: StatusMap = {
    Online: 'omnichannel_available',
    Offline: 'omnichannel_offline',
    Busy: 'omnichannel_busy',
  };

  private agentStatusMap: AgentStatusMap = {
    available: AgentStatus.AVAILABLE,
    unavailable: AgentStatus.UNAVAILABLE,
  };

  constructor() {
    return (
      CrmToAircallStatusMapper.ins ?? (CrmToAircallStatusMapper.ins = this)
    );
  }
  async mapAgentStatus(status: string): Promise<AgentStatus> {
    return this.agentStatusMap[status];
  }

  async mapPhoneStatus(status: string): Promise<string> {
    return this.phoneStatusMap[status];
  }

  async getDefaultCRMKey(status: StatusSyncCrmToAircallInput): Promise<string> {
    const statusName = status.isOffline
      ? 'Offline'
      : !status.isOffline && status.hasChannels
      ? 'Online'
      : 'Busy';
    return this.defaultCRMKeyMap[statusName];
  }
}
